import {observable} from 'mobx';

export interface Account {
    _id: string;
    companyName: string;
    selected?: boolean;
}

export class ChangeAccountModalState {
    @observable isVisible: boolean = false;
    @observable accounts: Account[] = [];
    @observable selectedAccountId: string | null = null;
    @observable loading: boolean = false;
    @observable saving: boolean = false;
}
